import request from "./axios";

// Admin settings for the daily 8am overdue sales emails.

function get() {
  return request({
    method: "get",
    url: `/overdue_sales_email_settings`
  })
}

function update(settings) {
  return request({
    method: "patch",
    url: `/overdue_sales_email_settings`,
    data: settings
  })
}

function preview() {
  return request({
    method: "post",
    url: `/overdue_sales_email_settings/preview`
  })
}

const OverdueSalesEmailsService = {
  get, update, preview
};

export default OverdueSalesEmailsService;
